import api from "../../api"; 

const baseURL = process.env.REACT_APP_BASE_URL + "/entityexchange";

class ExchangeService {

    createExchange(exchange){
        return api.post(baseURL + "/save", exchange);
    }

    getExchangeById(exchangeId){
        return api.get(baseURL + '/exchange/search?idNum=' + exchangeId);
    }    

    updateExchange(exchange){
        return api.post(baseURL + "/exchange", exchange);
    }

    deleteExchange(exchangeId){
        return api.post(baseURL + '/exchange/delete?exchange=' + exchangeId);
    }

    deleteExchangeById(idNum){
        return api.post(baseURL + '/exchange/delete?idNum=' + idNum);
    }

    deleteBatchExchange(exchange){
        return api.post(baseURL + '/deleteall',  exchange);
    }

    
}

export default new ExchangeService()